export default "__VITE_ASSET__7778c964__"